/* eslint-disable react/prop-types */
import React/* , { useState } */ from 'react'
import { HiOutlineSearch } from 'react-icons/hi'
import { Search } from './styles'
import { trackClick } from '../../utils/gtm'
import { tagIdFromLegacySuffix } from '../../utils/marketplaceTagIds'
import { useScreenTracking } from '../../hooks/useScreenTracking' 

export default function SearchComponent (props) {
  const screenName = useScreenTracking();

  const handleSearchClick = () => {
    trackClick({
      title: "abrir-busca",
      contentType: "header",
      screenName,
      tagId: tagIdFromLegacySuffix("01"),
    });
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <>
      <Search>
        <button onClick={handleSearchClick}><HiOutlineSearch/></button>
      </Search>
    </>
  )
}
